<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">

        <!-- 左边 -->
        <div style="margin:5px;float:right">
            <el-button size="mini" type="success" @click="openModel">添加内容</el-button>
        </div>
        <el-button size="mini" type="danger" @click="deleclick" style="margin:5px">批量删除</el-button>
        <el-table :data="tableData" border style="width: 100%" v-loading="loadings" ref="configurationTable"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="title" label="标题" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="author" label="作者" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="source" label="来源" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="status_text" label="状态" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column label="操作" width="250" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" size="mini">编辑</el-button>
                    <el-button @click="deleteClick(scope.row)" type="danger" size="mini">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="float:right">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="curPage"
                :page-sizes="[15, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="count">
            </el-pagination>
        </div>

        <el-dialog :title="names" :visible.sync="dialogVisible" top='20px'>
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
                    <el-form-item label="栏目">
                        <el-cascader placeholder="请选择" v-model="ruleForm.mid" :options="hospital_options" filterable
                            :props="{ value: 'id', label: 'cate_name' ,children :'child'  ,checkStrictly: true }"
                            size='small' clearable></el-cascader>
                    </el-form-item>
                    <el-form-item label="标题" prop="title">
                        <el-input v-model="ruleForm.title" placeholder="请输入内容" style="width:50%"></el-input>
                    </el-form-item>
                    <el-form-item label="作者">
                        <el-input v-model="ruleForm.author" placeholder="请输入内容" style="width:50%"></el-input>
                    </el-form-item>
                    <el-form-item label="来源">
                        <el-input v-model="ruleForm.source" placeholder="请输入内容" style="width:50%"></el-input>
                    </el-form-item>
                    <el-form-item label="内容">
                        <WangEditor ref="editor1" @editorContent="changeEditor" :editorContent="ruleForm.editorContent"
                            :operateflag="ruleForm.operateflag" />
                    </el-form-item>
                    <el-form-item label="图片">
                        <div>
                            <span v-if="!ruleForm.image" class="btn btn-light border mr-2" @click="chooseImage">
                                <i class="el-icon-plus"></i>
                            </span>
                            <img v-if="ruleForm.image"
                                :src="ruleForm.image" class="rounded"
                                style="width: 100px;height: 100px;cursor: pointer;" @click="chooseImage" />
                            <!-- <video v-bind:src="ruleForm.image" style="width: 100px;height: 100px;cursor: pointer;"
                                class="rounded" @click="chooseImage"
                                v-if="ruleForm.image && ruleForm.image.substring(ruleForm.image.lastIndexOf('.')+1) == 'mp4'">
                            </video> -->
                        </div>
                    </el-form-item>
                    <el-form-item label="视频">
                        <div>
                            <span v-if="!ruleForm.video" class="btn btn-light border mr-2" @click="chooseVideo">
                                <i class="el-icon-plus"></i>
                            </span>
                            <!-- <img v-if="ruleForm.image && ruleForm.image.substring(ruleForm.image.lastIndexOf('.')+1) != 'mp4'" :src="ruleForm.image" class="rounded"
                                style="width: 100px;height: 100px;cursor: pointer;" @click="chooseImage" /> -->
                            <video :src="ruleForm.video" style="width: 100px;height: 100px;cursor: pointer;"
                                class="rounded" @click="chooseVideo"
                                v-if="ruleForm.video">
                            </video>
                        </div>
                    </el-form-item>
                    <el-form-item label="关键词">
                        <el-input v-model="ruleForm.keywords" placeholder="请输入内容" style="width:50%"></el-input>
                    </el-form-item>
                    <el-form-item label="描述">
                        <el-input v-model="ruleForm.description" placeholder="请输入内容" style="width:50%"></el-input>
                    </el-form-item>
                    <el-form-item label="跳转地址">
                        <el-input v-model="ruleForm.url" placeholder="请输入内容" style="width:50%"></el-input>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input v-model="ruleForm.sort" placeholder="请输入内容" style="width:50%"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size='small'>取 消</el-button>
                <el-button @click="subForm" size='small' type="primary">提交</el-button>
            </span>
        </el-dialog>




    </div>
</template>

<script>
    import buttonSearch from "@/components/common/button-search.vue"
    import common from '@/common/mixins/common.js';
    const WangEditor = () => import('@/components/wangEnduit/index')
    export default {
        inject: ['app', 'layout'],
        mixins: [common],
        components: {
            buttonSearch,
            WangEditor,
        },
        data() {
            return {
                names: '',
                tableData: [],
                loadings: false,
                pageSize: 15,
                curPage: 1,
                count: 0,
                dialogVisible: false,
                hospital_options: [],
                ruleForm: {
                    mid: '',
                    title: '',
                    author: '',
                    source: '',
                    image: '',
                    video:'',
                    keywords: '',
                    description: '',
                    url: '',
                    sort: '',
                    // 富文本
                    editorContent: "",
                    // 默认 是新增
                    operateflag: "add",

                },
                rules: {
                    title: [{
                        required: true,
                        message: '标题不能为空',
                        trigger: 'blur'
                    }]
                },
                eid: '',
                namesclick: false,
                multipleSelection: [],
                oder: [],
            }
        },
        computed: {

        },
        mounted() {
            let that = this
            that.getlist()
            that.getlm()
        },
        methods: {
            getlm() {
                let that = this
                axios
                    .post("/admin/lgTpCate/index", {}, {
                        token: true
                    })
                    .then(response => {
                        that.hospital_options = response.data.data
                    })
                    .catch(error => {})
            },
            getlist() {
                let that = this
                that.loadings = true
                axios
                    .post("/admin/lgTpArticle/index", {}, {
                        token: true
                    })
                    .then(response => {
                        that.tableData = response.data.data.data
                        that.count = response.data.data.total
                        that.loadings = false
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pageSize = val
                that.getlist()
            },
            handleCurrentChange(val) {
                let that = this
                that.curPage = val
                that.getlist()
            },
            // 选择图片
            chooseImage() {
                this.app.chooseImage((res) => {
                    console.log("图片",res);
                    this.ruleForm.image = res[0].url
                }, 1)
            },
            chooseVideo() {
                this.app.chooseImage((res) => {
                    console.log("视频",res);
                    this.ruleForm.video = res[0].url
                    console.log(this.ruleForm.video);
                }, 1)
            },
            getcontent() {
                let that = this;
                axios
                    .post(
                        "/admin/lgTpArticle/getDataById", {
                            id: that.eid
                        }, {
                            token: true,
                        }
                    )
                    .then((response) => {
                        that.ruleForm.editorContent = response.data.data.content
                    })
                    .catch((error) => {});

            },
            openModel() {
                let that = this
                that.ruleForm.operateflag = "add";
                that.names = "新增"
                that.namesclick = false
                that.dialogVisible = true
                that.ruleForm.editorContent = "";
                that.ruleForm.mid = ''
                that.ruleForm.title = ''
                that.ruleForm.author = ''
                that.ruleForm.source = ''
                that.ruleForm.image = ''
                that.ruleForm.video = ''
                that.ruleForm.keywords = ''
                that.ruleForm.description = ''
                that.ruleForm.url = ''
                that.ruleForm.sort = ''
            },
            handleClick(row) {
                let that = this
                that.dialogVisible = true

                that.ruleForm.operateflag = "edit";

                that.names = "编辑"
                that.namesclick = true
                that.eid = row.id
                // that.ruleForm.editorContent = row.content;
                that.ruleForm.mid = row.cate_id
                that.ruleForm.title = row.title
                that.ruleForm.author = row.author
                that.ruleForm.source = row.source
                that.ruleForm.image = row.image
                that.ruleForm.video = row.video
                that.ruleForm.keywords = row.keywords
                that.ruleForm.description = row.description
                that.ruleForm.url = row.url
                that.ruleForm.sort = row.sort
                that.getcontent()

            },
            subForm() {
                let that = this
                if (that.names == "新增") {
                    axios
                        .post("/admin/lgTpArticle/Madd", {
                            cate_id: that.ruleForm.mid.toString(),
                            title: that.ruleForm.title,
                            author: that.ruleForm.author,
                            source: that.ruleForm.source,
                            image: that.ruleForm.image,
                            video: that.ruleForm.video,
                            keywords: that.ruleForm.keywords,
                            description: that.ruleForm.description,
                            url: that.ruleForm.url,
                            sort: that.ruleForm.sort,
                            //    id:that.namesclick = false?0:that.eid,
                            content: that.ruleForm.editorContent
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == 200) {
                                this.$message({
                                    showClose: true,
                                    type: 'success',
                                    message: response.data.msg

                                });
                                that.getlist()
                                that.dialogVisible = false
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.data.msg,
                                    type: 'error'
                                });
                            }
                        })
                        .catch(error => {})
                }
                if (that.names == "编辑") {
                    axios
                        .post("/admin/lgTpArticle/Medit", {
                            cate_id: that.ruleForm.mid.toString(),
                            title: that.ruleForm.title,
                            author: that.ruleForm.author,
                            source: that.ruleForm.source,
                            image: that.ruleForm.image,
                             video: that.ruleForm.video,
                            keywords: that.ruleForm.keywords,
                            description: that.ruleForm.description,
                            url: that.ruleForm.url,
                            sort: that.ruleForm.sort,
                            id: that.eid,
                            content: that.ruleForm.editorContent
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == 200) {
                                this.$message({
                                    showClose: true,
                                    type: 'success',
                                    message: response.data.msg

                                });
                                that.getlist()
                                that.dialogVisible = false
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.data.msg,
                                    type: 'error'
                                });
                            }
                        })
                        .catch(error => {})
                }

            },
            // 富文本编辑器内部变更时回调父组件的方法
            changeEditor(param) {
                let that = this
                that.ruleForm.editorContent = param;
            },
            deleteClick(row) {
                let that = this
                // this.deleid = row.id 
                // axios.post("/admin/lgTpArticle/Mdelete", {
                //     ids:[this.deleid]
                // },{
                //     token: true
                // }).then(response =>{

                // })
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/lgTpArticle/Mdelete", {
                            ids: [row.id],
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.getlist()
                            } else {
                                that.$alert(response.data.message)
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleSelectionChange(val) {
                this.multipleSelection = val
                this.oder = []
                this.multipleSelection.forEach(element => {
                    this.oder.push(element.id)
                });
            },

            deleclick() {
                let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/lgTpArticle/Mdelete", {
                            ids: this.oder,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.getlist()
                            } else {
                                that.$alert(response.data.message)
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }

        },
    }
</script>

<style>
</style>